<template lang="pug">
    div#app
        h1 游戏记录表
        div.game
            div.gamer
                header
                    div
                        input.inputGamer.form-control(placeholder="添加玩家",v-model="name")
                        button.buttonGamer.btn.btn-primary(@click="handleClickAddGamer") 添加玩家
                        button.buttonGamer.btn.btn-danger(@click="handleClickDeleteGamer") 删除玩家
                    div
                        button.gameover.btn.btn-success.form-control(@click="handleClickGameover") 结束游戏
                main   
                    table.table
                        thead
                            tr
                                th 轮数
                                th(v-for="(g,gi) in gamers" :key="gi") {{g.name}}
                                th 操作
                        tbody
                            tr
                                td 增量
                                td(v-for="(g,gi) in gamers")
                                    input(type="number",v-model.number="g.delta")
                                td  
                                    button.btn.btn-primary(@click="handleClickRecord") 记录
                            tr
                                td 总计
                                td(v-for="(t,ti) in total") {{t}}
                            tr(v-for="(r,ri) in records")
                                td {{records.length-ri}}
                                td(v-for="(c,ci) in r") {{c}}
                                td
                                    button.cancel.btn.btn-danger(v-if="!ri",@click="handleClickCancel") 撤销

        div.games
            div.game(v-for="(G,Gi) in games")
                h5 {{G.date}}
                table.table
                        thead
                            tr
                                th 轮数
                                th(v-for="(g,gi) in G.gamers" :key="gi") {{g.name}}
                        tbody
                            tr
                                td 总计
                                td(v-for="(t,ti) in getTotal(G.gamers)") {{t}}
                            tr(v-for="(r,ri) in getRecords(G.gamers)")
                                td {{getRecords(G.gamers).length-ri}}
                                td(v-for="(c,ci) in r") {{c}}
                button.btn.btn-danger(@click="handleClickDeleteGame(Gi)") 删除记录
                
        
</template>

<script>
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import localforage from "localforage/dist/localforage.min.js";
export default {
  name: "App",
  data: function() {
    return {
      gamers: [],
      name: "",
      games: []
    };
  },
  created:async function(){
      this.gamers=await localforage.getItem("gamers") || [];
      this.games=await localforage.getItem("games") || [];
  },
  computed: {
    records: function() {
      return this.getRecords(this.gamers);
    },
    total: function() {
      return this.getTotal(this.gamers);
    }
  },
  watch:{
      gamers:{
          handler:function(val){
              localforage.setItem("gamers",val);
          },
          deep:true
      },
      games:{
          handler:function(val){
              localforage.setItem("games",val);
          },
          deep:true
      },
      
  },
  methods: {
    getRecords(gamers) {
      var records = [];
      if (gamers.length) {
        for (let index = 0; index < gamers[0].records.length; index++) {
          var record = [];
          for (let i = 0; i < gamers.length; i++) {
            record.push(gamers[i].records[index]);
          }

          records.unshift(record);
        }
      }
      return records;
    },
    getTotal(gamers) {
      return gamers.map(gamer => {
        return gamer.records.reduce(function(pre, cur) {
          return parseInt(pre) + parseInt(cur);
        }, 0);
      });
    },
    handleClickAddGamer() {
      if (
        this.name &&
        !this.gamers.map(name => name.name).includes(this.name)
      ) {
        this.gamers.push({ name: this.name, delta: 0, records: [] });
        this.name = "";
      }
    },
    handleClickDeleteGamer() {
      if (this.gamers.length) {
        this.gamers.pop();
      }
    },
    handleClickRecord() {
      this.gamers.forEach(gamer => {
        gamer.records.push(parseInt(gamer.delta));
        // gamer.delta=0;
      });
    },
    handleClickCancel() {
      this.gamers.forEach(gamer => {
        gamer.records.pop();
      });
    },
    handleClickGameover() {
        if (this.records.length) {
            this.games.unshift({
              date: new Date().toLocaleString(),
              gamers: this.gamers
            });
            this.gamers = [];
        }
    },
    handleClickDeleteGame(Gi){
        this.games.splice(Gi,1);
    }
  }
};
</script>

<style lang="less" scoped>
* {
  margin: 5px;
}
#app {
  text-align: center;
  h1 {
    text-align: center;
    font-family: "kaiti";
    color: #d35400;
    text-shadow: 2px 2px 3px #aaa;
  }
  .game {
    .gamer {
      header {
        div {
          input {
            text-align: center;
          }
          button.buttonGamer {
            width: 100%;
          }
        }
      }
      main {
        table {
          thead {
            tr {
              th:first-child {
                width: 4em;
              }
              th:last-child {
                width: 6em;
              }
            }
          }
          tbody {
            tr {
              td {
                input {
                  text-align: center;
                  width: 100%;
                  margin: 0;
                  border: none;
                  border-bottom: 1px solid rgb(116, 116, 116);
                }
                button {
                  margin: 0;
                }
              }
            }
          }
        }
      }
    }
  }
  .games {
    .game {
      margin: 100px 0;
      h5 {
        text-align: center;
        margin-bottom: 2em;
      }
    }
  }
}
</style>